import { z } from "zod";
/**
 * Gemeinsame Typen und Schemas fuer Backend und Frontend.
 *
 * Alles hier wird von beiden Seiten importiert. Das Backend validiert damit
 * eingehende Daten, das Frontend leitet daraus seine Typen ab. So kann eine
 * Feldaenderung nicht nur auf einer Seite passieren.
 */
/** Antwort von GET /api/health. */
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    version: z.string(),
    time: z.string(),
});
/**
 * Fehlerantwort. Bewusst knapp gehalten: `code` ist maschinenlesbar,
 * `message` ist fuer Menschen und enthaelt niemals interne Details.
 */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});
/**
 * Die reservierte PIN, die den Vault-Einstieg startet.
 *
 * Ausdruecklich KEIN Sicherheitsmerkmal: sie schuetzt nichts und autorisiert
 * nichts. Sie ist nur ein versteckter Einstiegspunkt, der den Authentik-Login
 * ausloest. Die eigentliche Absicherung sind OIDC + TOTP.
 *
 * Sie darf niemals als normale Throw-PIN vergeben werden.
 */
export const VAULT_ENTRY_PIN = "1306";
/** Genau vier Dezimalziffern, als String, damit fuehrende Nullen erhalten bleiben. */
export const throwPinSchema = z
    .string()
    .regex(/^[0-9]{4}$/, "PIN muss aus genau vier Ziffern bestehen");
/** Sechsstelliger TOTP-Code. */
export const totpCodeSchema = z
    .string()
    .regex(/^[0-9]{6}$/, "Code muss aus genau sechs Ziffern bestehen");
/**
 * Authentifizierungsstufen einer Airspace-Sitzung.
 *
 * Die Stufen sind aufsteigend: jede hoehere schliesst die niedrigeren ein.
 * Vault-Endpunkte verlangen `vault_totp_verified`, Throw im Modus `required`
 * verlangt nur `oidc_authenticated`.
 */
export const authLevels = ["anonymous", "oidc_authenticated", "vault_totp_verified"];
/** Numerischer Rang einer Stufe, fuer Vergleiche wie "mindestens". */
export function authLevelRank(level) {
    return authLevels.indexOf(level);
}
/** Prueft, ob `actual` mindestens die Stufe `required` erreicht. */
export function meetsAuthLevel(actual, required) {
    return authLevelRank(actual) >= authLevelRank(required);
}
//# sourceMappingURL=api-types.js.map